var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import styled from 'styled-components';
import { Button, Flex, getPaletteColor, Label, Relative, Text, Tooltip } from 'pcln-design-system';
import { Calendar, Warning } from 'pcln-icons';
var WarningIcon = styled(Warning)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    z-index: ", ";\n  }\n"], ["\n  &&& {\n    z-index: ", ";\n  }\n"])), function (props) { return props.zIndex + 1; });
var DateFieldButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &&& {\n    background-color: ", ";\n    ", "\n  }\n\n  &&&:focus {\n    ", "\n  }\n"], ["\n  &&& {\n    background-color: ", ";\n    ", "\n  }\n\n  &&&:focus {\n    ", "\n  }\n"])), getPaletteColor('background.lightest'), function (props) { return (props.borderColor ? "border-color: ".concat(getPaletteColor(props.borderColor)(props)) : ''); }, function (props) {
    return props.borderColor
        ? "\n        box-shadow: 0 0 0 2px ".concat(getPaletteColor(props.borderColor)(props), ";\n        border-color: ").concat(getPaletteColor(props.borderColor)(props), ";\n      ")
        : '';
});
function DateField(_a) {
    var _b;
    var ariaDescription = _a.ariaDescription, className = _a.className, error = _a.error, height = _a.height, _c = _a.hideTooltip, hideTooltip = _c === void 0 ? false : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d, label = _a.label, name = _a.name, value = _a.value, _e = _a.zIndex, zIndex = _e === void 0 ? 3 : _e, onBlur = _a.onBlur, onClick = _a.onClick, onFocus = _a.onFocus, props = __rest(_a, ["ariaDescription", "className", "error", "height", "hideTooltip", "isMobile", "label", "name", "value", "zIndex", "onBlur", "onClick", "onFocus"]);
    var buttonHeight = height ? height : isMobile ? 46 : 56;
    var showError = !!error;
    var showErrorTooltip = showError && !hideTooltip;
    return (React.createElement(Relative, __assign({ className: className }, props, { zIndex: zIndex }),
        React.createElement(DateFieldButton, { variation: 'input', borderRadius: 'lg', py: 0, px: 2, height: buttonHeight, borderColor: showError ? 'error.base' : undefined, onBlur: onBlur, onClick: onClick, onFocus: onFocus, "data-testid": 'date-field-input', value: value, name: name, "aria-description": ariaDescription || "".concat(value ? 'Change' : 'Select', " travel dates") },
            React.createElement(Flex, { width: '100%', justifyContent: 'space-between', alignItems: 'center' },
                React.createElement(Flex, { alignItems: 'center' },
                    React.createElement(Calendar, { mr: 2, color: 'primary.base' }),
                    React.createElement(Flex, { flexDirection: 'column' },
                        value && (React.createElement(Label, { as: 'div', mb: 0 }, label)),
                        !value && (React.createElement(Text, { color: 'text.light', fontSize: [2, null, null, 1] }, label)),
                        value && React.createElement(Text, { fontSize: [2, null, null, 1] }, value))),
                showError && React.createElement(WarningIcon, { title: 'warning', color: 'error', size: 20, zIndex: zIndex }))),
        showErrorTooltip && (React.createElement(Tooltip, { bottom: true, right: true, color: 'error', zIndex: ((_b = Number(zIndex)) !== null && _b !== void 0 ? _b : 3) + 2 }, error))));
}
export default memo(DateField);
var templateObject_1, templateObject_2;
//# sourceMappingURL=DateField.js.map